import React, {useEffect, useState} from "react";
import {StmStateDto} from "../../common/dto/stm-state-dto";
import {ACTION_PROMPT} from "../../common/const/settings-type";
import SlotSelector from "../../common/components/slot-selector";
import TextBox from "../../../../components/forms/text-box";
import TextArea from "../../../../components/forms/text-area";
import SettingTip from "../../common/components/setting-tip";
import MultiSelect from "../../../../components/forms/multi-select-drop-down";
import DynamicRows from "../../../../components/dynamic-rows";
import SentToUserSwitch from "../../common/components/send-to-user-switch";
import { listDataSources } from "../../../../services/knowledge";
import { useAppInfo } from "../../../../helpers/hooks/common-hook";
import SwitchComponent from "../../../../components/switch";

const prepareRawsData = (data=[]) => {
    return data.map(header=>({inputs: header}))
}

function QuestionPromptSettings({ name, onChangeData, savedSettings, metadata }) {
    const { appId } = useAppInfo();

    const [formData, setFormData] = useState(savedSettings);
    const [kbList, setKBList] = useState([]);

    const [executorFormData, setExecutorFormData] = useState({
        inputPrompt: '',
        slotToAssign: '',
        topK: 20
    });

    const notifyOnchangeData = data => {
        data.stateType = ACTION_PROMPT
        onChangeData(data);
    }

    const fetchKB = async () => {
        try {
            let {response} = await listDataSources(appId);
            const options = response.data.map(ds => ({
                id: ds.dataSourceId,
                label: ds.dataSourceId,
                internalId: ds.id,
                fileType: ds.fileType
            }));
            setKBList(options);
        } catch(err) {

        }
        
    }

    useEffect(() => {
        fetchKB()
    }, []);

    useEffect(() => {
        notifyOnchangeData(formData)

        if (formData.assignToSlots && formData.assignToSlots.executors && formData.assignToSlots.executors.length > 0) {
            setExecutorFormData({...formData.assignToSlots.executors[0]})
        }

    }, [formData]);

    const handleChange = event => {
        const targetName = event.target.name;
        const targetValue = event.target.value;
        const newFormData = {...formData}
        newFormData[targetName] = targetValue;
        setFormData(newFormData);
    };

    const handleChangeKBFilterMulti = (selectedIds = []) => {
        const newFormData = { ...formData };
        newFormData['filterKb'] = selectedIds;

        // compute files for selected knowledge bases using kbList metadata
        const files = selectedIds
            .map(kbId => kbList.find(o => o.id === kbId))
            .filter(Boolean)
            .map(opt => `${appId}-${opt.internalId}.${opt.fileType}`);

        newFormData['dataSourceFiles'] = files;

        setFormData(newFormData);
    };

    return (
        <div className="flex flex-col gap-2">

            <SettingTip text="Generate Answer by referring uploaded Documents"/>

            <TextBox
                label="Name"
                type="text"
                name="name"
                placeholder="State name"
                value={formData.name}
                onChange={handleChange}
            />

            <MultiSelect
                rootClass="pt-2"
                label="Filter by Knowledge"
                id="filterKb"
                selectedOptions={Array.isArray(formData.filterKb) ? formData.filterKb : (formData.filterKb ? [formData.filterKb] : [])}
                options={kbList}
                onChangeOptions={handleChangeKBFilterMulti}
            />

            <div className="pt-4 pb-2">
                <SwitchComponent
                    title="File Read"
                    subTitle="Answer by reading the file"
                    enabled={formData.readFile}
                    onChange={state => {
                      handleChange({ target: { name: 'readFile' , value: state }})
                  }}
                  />
            </div>
            

            <TextArea
                rootClass={"pt-2"}
                label="Instruction"
                type="text"
                name="systemPrompt"
                placeholder="Eg: you are helpful chatbot"
                value={formData.systemPrompt}
                onChange={handleChange}
            />

            <TextArea
                rootClass="pt-2"
                label="Question"
                type="text"
                name="inputPrompt"
                placeholder="Eg: do you delivery to {city}"
                value={formData.inputPrompt}
                onChange={handleChange}
            />

            <TextArea
                rootClass={"pt-2"}
                label="Output Format"
                type="text"
                name="outputFormat"
                placeholder="Add expected output format"
                value={formData.outputFormat}
                onChange={handleChange}
            />

            {!formData.readFile &&
                <TextBox
                    rootClass="pt-2"
                    label="Top Results"
                    type="number"
                    name="topK"
                    id="topK"
                    value={formData.topK}
                    placeholder="Best matching top results count"
                    onChange={handleChange}
                />
            }
            

            {/* <DropDown
                label="Set response"
                className="pt-2"
                placeHolder="Assign To Slot"
                name="slotToAssign"
                value={formData.slotToAssign}
                options={Object.keys(metadata.slots)}
                onChange={handleChange}
            /> */}

            <SlotSelector 
                            label="Set response"
                            value={formData.slotToAssign}
                            autoFillFromEntity={false} 
                            slots={metadata.slots} 
                            showCaptureFromUserInput={false}
                            onChange={(e)=>handleChange({target: { name: 'slotToAssign', value: e.target.value }})} 
                            />

            <SentToUserSwitch formData={formData} setFormData={setFormData} skipNotify={formData.skipNotify}/>


        </div>
    )
}

export default QuestionPromptSettings
